export default {
    init: function () {
        if ($('.tabbed-section').length === 0 && $('.content-accordion-wrapper').length === 0) return;
        this.bindEvents();
    },

    toggleActive: function ($$) {
        let parent = $$.parent('.single-tab'),
            content = parent.find('.tab-content');

        if (parent.hasClass('open')) {
            parent.removeClass('open');
            content.slideUp();
        } else {
            parent.parent().find('.single-tab').removeClass('open');
            parent.addClass('open');
            parent.parent().find('.tab-content').slideUp();
            content.slideDown();
        }

        if (parent.parent('.ecosystem-tabs').length) {
            this.setEcosystemImageState(parent.hasClass('open') ? parent.data('state') : 0);
        }
    },

    changeActiveImage: function ($$) {
        let imageWrapper = $('.image-wrapper-inner'),
            activeTab = $$.data('tab'),
            activeImage = $(`[data-image='${activeTab}']`);
        if (!activeImage.hasClass('display-none')) return;

        imageWrapper.addClass('display-none');
        activeImage.addClass('blur-animation');
        activeImage.removeClass('display-none ');
        setTimeout(function () {
            activeImage.removeClass('blur-animation');
        }, 400);
    },

    setEcosystemImageState: function (activeTab) {
        let wrapper = $('.ecosystem-graphic-wrapper');
        wrapper.removeClass('state-0 state-1 state-2 state-3 state-4');
        wrapper.addClass('state-' + activeTab);
    },

    toggleTabFromImage($$) {
        let targetId = $$.data('tab-image-toggle');
        let newTrigger = $('[data-state=' + targetId + ']').find('.tab-title');
        this.toggleActive(newTrigger);
    },

    bindEvents: function () {
        let _this = this;
        $('.single-tab .tab-title').click(function () {
            _this.toggleActive($(this));
        });
        $('.accordion-image-tab').on('click', function () {
            _this.changeActiveImage($(this));
        });
        $('[data-tab-image-toggle]').on('click', function () {
            _this.toggleTabFromImage($(this));
        });
    },
};